<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-6.79,796.32l7.29-7.28l7.28,7.28l2.72-2.71l-10-10l-10,10L-6.79,796.32z M-4.59,801.4l5.09-5.08l5.08,5.08l1.36-1.36
	L0.5,793.6l-6.44,6.44L-4.59,801.4z"/>
</svg>

</template>